import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=39b6315a"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b6315a')) {
      api.createRecord('39b6315a', component.options)
    } else {
      api.reload('39b6315a', component.options)
    }
    module.hot.accept("./PhotoUpload.vue?vue&type=template&id=39b6315a", function () {
      api.rerender('39b6315a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhotoUpload.vue"
export default component.exports